import { useContext } from "react";
import AuthContext from "../Contexts/JWTAuthContext";

const useAuth = () => useContext(AuthContext);

export default useAuth;
